var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGendre({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48603",
    "data-name": "Group 48603",
    transform: "translate(-1165 -671)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138034",
    "data-name": "Rectangle 138034",
    width: 24,
    height: 24,
    transform: "translate(1165 671)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48570",
    "data-name": "Group 48570",
    transform: "translate(-29.75 -8.75)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    y1: 6.087,
    transform: "translate(1204.663 696.344)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x2: 4.348,
    transform: "translate(1202.489 700.257)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    x1: 4.624,
    y2: 4.624,
    transform: "translate(1208.474 681.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93210",
    "data-name": "Path 93210",
    d: "M10.054.75H13.1V3.793",
    transform: "translate(1200 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93211",
    "data-name": "Path 93211",
    d: "M5.452,7.6a3.915,3.915,0,0,1,3.124,3.834c0,.06,0,.12,0,.179A3.913,3.913,0,0,1,.75,11.431",
    transform: "translate(1200 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93212",
    "data-name": "Path 93212",
    d: "M4.858,11.962A3.913,3.913,0,1,1,9.619,8.141",
    transform: "translate(1200 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGendre);
export default __webpack_public_path__ + "static/media/gendre.4db954e1782e78a60cf018252d652df5.svg";
export { ForwardRef as ReactComponent };